<template>
  <div class="w-full font-proxima">
    <div class="overflow-x-auto shadow-sm ring-1 ring-black ring-opacity-5 rounded-sm bg-white">
      <table class="min-w-full divide-y divide-gray-300">
        <thead class="bg-red-50">
          <tr>
            <th v-for="header in HEADERS" :key="header" class="p-2 text-left align-middle text-sm font-bold border border-white text-blue-500 whitespace-nowrap">
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          <tr v-for="(row, index) in rows" :key="row.id ?? index" :class="index % 2 === 0 ? undefined : 'bg-gray-100'">
            <td class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ name(row) }}</td>
            <td class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ dateTime(row.startTime) }}</td>
            <td class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ row.status }}</td>
            <td class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ format(row) }}</td>
            <td class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ row.userFullName }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="mt-1 text-xs text-gray-500">
      Showing {{ rows.length.toLocaleString() }} of {{ (output?.count ?? rows.length).toLocaleString() }} appointments
    </p>
  </div>
</template>
<script setup lang="ts">
interface AppointmentRow {
  id?: string;
  firstName?: string;
  lastName?: string;
  startTime?: string;
  status?: string;
  userFullName?: string;
  isVirtual?: boolean;
  isPhone?: boolean;
  isInPerson?: boolean;
}

const props = defineProps<{ part: { output?: { count?: number; appointments?: AppointmentRow[] } } }>();

const HEADERS = ['Applicant', 'When', 'Status', 'Format', 'Staff'];

const output = computed(() => props.part.output);
const rows = computed<AppointmentRow[]>(() => output.value?.appointments ?? []);

const name = (row: AppointmentRow) => [row.firstName, row.lastName].filter(Boolean).join(' ');
const format = (row: AppointmentRow) =>
  row.isVirtual ? 'Virtual' : row.isPhone ? 'Phone' : row.isInPerson ? 'In person' : '';
const dateTime = (value?: string) =>
  value ? new Date(value).toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', hour: 'numeric', minute: '2-digit' }) : '';
</script>
